import { useSearchParams } from "react-router-dom";

const useParamsHandler = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsHandler = (
    key: string,
    value: string | number,
    key1?: string,
    value1?: string,
  ) => {
    var params: any = {};
    searchParams.forEach((value: string, key: string) => (params[key] = value));

    if (
      key === "userType" ||
      key === "status" ||
      key === "search" ||
      key === "limit"
    ) {
      setSearchParams({
        ...params,
        [key]: value,
        page: 1,
      });
    } else if (key1) {
      setSearchParams({
        ...params,
        [key]: value,
        [key1]: value1,
        page: 1,
      });
    } else {
      setSearchParams({
        ...params,
        [key]: value,
      });
    }
  };
  return { searchParams, searchParamsHandler };
};

export default useParamsHandler;
